import React, { memo } from 'react';
import { string } from 'prop-types';
import Radium from 'radium';
import { WithLoading } from '@widergy/energy-ui';

import UTForm from 'app/components/UTForm';
import { appConfig } from 'config/customization';
import {
  genderField,
  documentNumberField,
  documentTypeField,
  emailField,
  passwordField
} from 'constants/fields';

import { ReactComponent as User } from './assets/user.svg';
import { ReactComponent as Password } from './assets/password.svg';
import styles from './styles';
import stylesSCSS from './styles.module.scss';

const SignIn = ({ documentType, documentNumber }) => {
  const gender =
    appConfig.signIn.conditionalRequestGender &&
    documentType === 'dni' &&
    documentNumber >= appConfig.signIn.minDocNumber &&
    documentNumber <= appConfig.signIn.maxDocNumber
      ? [genderField]
      : [];
  const fields =
    appConfig.signInMethod === 'documentType'
      ? [documentTypeField, documentNumberField, ...gender, passwordField]
      : [
          {
            ...emailField,
            configuration: {
              outsideIcon: appConfig.signIn.iconField && <User className={stylesSCSS.icon} />
            }
          },
          {
            ...passwordField,
            configuration: {
              outsideIcon: appConfig.signIn.iconField && <Password className={stylesSCSS.icon} />
            }
          }
        ];

  const fieldValues = { document_number: documentNumber, document_type: documentType };

  return <UTForm fields={fields} fieldValues={fieldValues} fieldClasses={{ container: styles.noShrink }} />;
};

SignIn.propTypes = {
  documentType: string,
  documentNumber: string
};

export default WithLoading(props => props.loading)(memo(Radium(SignIn)));
